module.exports = __webpack_public_path__ + "img/direction-2@3x.163f6b06.png";